import script from "./BuyerSelector.vue?vue&type=script&setup=true&lang=js"
export * from "./BuyerSelector.vue?vue&type=script&setup=true&lang=js"

import "./BuyerSelector.vue?vue&type=style&index=0&id=03d64d7f&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-03d64d7f"]])

export default __exports__